export let moreApps = "zfrnUe";
export let noApps = "hcA0c";
export let moreAppsAccessibleLabel = "DN7SDe";
export let addApps = "j$nFXb";
export let appsInMail = "KpnUWd";
export default {moreApps,noApps,moreAppsAccessibleLabel,addApps,appsInMail};